import React, { useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import FormattedPrice from 'components/FormattedPrice/FormattedPrice';
import styles from './NoPaymentProgress.module.scss';

type Props = {
  Model?: any;
  PageData?: any;
};

const NoPaymentProgress = ({ Model, PageData }: Props) => {
  const [textPercent, setTextPercent] = useState<number>(100);
  const [gradientPercent, setGradientPercent] = useState<number>(100);

  useEffect(() => {
    const paidBalanceSum = Model?.PaidBalanceSum
      ? parseFloat(Model.PaidBalanceSum) / 100
      : 0;
    const currentBalanceSum = Model?.CurrentBalanceSum
      ? parseFloat(Model?.CurrentBalanceSum) / 100
      : 0;
    const originalBalanceSum = Model.OriginalBalanceSum
      ? parseFloat(Model?.OriginalBalanceSum) / 100
      : 0;
    if (originalBalanceSum === 0) {
      setTextPercent(0);
      setGradientPercent(0);
    } else {
      let paid = paidBalanceSum;
      let percentpaid = paid > 0 ? (paid / originalBalanceSum) * 100 : 0;
      setGradientPercent(percentpaid - 10);
      setTextPercent(percentpaid);
    }
  }, [
    Model?.PaidBalanceSum,
    Model?.CurrentBalanceSum,
    Model.OriginalBalanceSum,
  ]);

  return (
    <div className={classNames(styles.wrapper, 'PayProgress')}>
      <div className="Grid Grid Grid--alignMiddle Grid--gutterHsm Grid--equalHeight">
        <div className="Grid-cell u-hidden u-md-size2of12">
          <div className="PayProgress-text PayProgressText-paid">
            <label>{PageData.PaidLabel}</label>
            <span>{Model?.FormattedCurrencyPaidBalanceSum}</span>
          </div>
        </div>
        <div className="Grid-cell">
          <div className="PayProgressBar-wrapper">
            <span
              className="PayProgressBar-text u-block "
              style={{ left: `0%` }}
            >
              {Model.PaidPercent}% {PageData.MyCurrentBalanceProgressbarLabel}
            </span>
            <div
              className="PayProgress-bar"
              style={{
                background: `linear-gradient(90deg, rgba(123,141,191,1) ${gradientPercent}%, rgba(225,221,221,1) ${Model.PaidPercent}%)`,
              }}
            ></div>
            <span
              className="PayProgressBar-text u-hidden  "
              style={{ left: `${textPercent}%`, transform: 'translateX(-50%)' }}
            >
              {Model.PaidPercent}% {PageData.MyCurrentBalanceProgressbarLabel}
            </span>
          </div>
        </div>

        <div className="Grid-cell u-hidden u-size1of2 u-md-size2of12 PayProgress__column PayProgressTextPaid-mob">
          <div className="PayProgress-text PayProgressText-paid">
            <label>{PageData.PaidLabel}</label>
            <span>{Model?.FormattedCurrencyPaidBalanceSum}</span>
          </div>
        </div>
        <div className="Grid-cell u-size1of2 u-md-size2of12 PayProgress__column u-hidden">
          <div className="PayProgress-text PayProgressText-balance">
            <label>{PageData.OriginalBalanceLabel}</label>
            <span>{Model.FormattedCurrencyOriginalBalanceSum}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoPaymentProgress;
